@if (open()) {

<div class="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm" (click)="onClose()"></div>

<div class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-2xl shadow-2xl
               w-full max-w-2xl
               h-[70vh]
               flex flex-col overflow-hidden" (click)="$event.stopPropagation()">

        <div class="flex justify-between border-b">
            <h1 class="p-3 fw-600">{{ 'REVERSTR0062' | translate }}</h1>
            <button class="p-3 fw-600" (click)="onClose()"><i class="pi pi-times"></i></button>
        </div>

        <!-- CONTENT -->
        <div class="w-full p-6 flex flex-col gap-3 overflow-y-auto flex-1">

            @for (item of data(); track item.servicE_CD) {
            <div class="flex flex-col p-2 rounded-xl border gap-3 relative transition-all bg-[#F5F5F5] border-gray-200">

                <div class="flex-1 min-w-0">
                    <div class="fs-14 truncate pr-6">{{ item.l_CLASS_NM }}</div>
                </div>

                <div class="grid grid-cols-3 gap-2 pr-10">
                    <div class="col-span-2">
                        <div class="flex gap-3">
                            <div class="fs-14">{{ item.s_CLASS_NM }}</div>
                            <div class="fs-14">{{ item.servicE_NM }}</div>
                        </div>
                    </div>

                    <div class="col-span-1">
                        <div class="flex justify-between gap-2">
                            <span class="font-bold text-red-500 fs-14">
                                {{ item.salE_QTY | number }}
                            </span>
                            <div class="text-right font-bold fs-14">
                                {{ (item.salE_UPRC * item.salE_QTY) | number }}
                                <span class="font-normal fs-14">
                                    {{ 'USERMAG0048' | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
        <!-- FOOTER -->
        <div class="sticky bottom-0 bg-white p-4">
            <div class="mt-auto px-6 py-3 bg-gray-700 text-gray-100 font-bold rounded-lg flex justify-end gap-6">
                <span>{{ 'BOOKGSTR0013' | translate }}</span>
                <span>{{ (data()?.[0]?.total_minutes ?? 0) | number }}</span>
            </div>

            <!-- <div class="mt-4 flex justify-end">
                <button (click)="onClose()"
                    class="px-6 py-3 bg-gray-100 text-gray-700 font-bold rounded-lg hover:bg-gray-200">
                    {{ 'Close' | translate }}
                </button>
            </div> -->
        </div>
    </div>
</div>

}